module.exports = __webpack_public_path__ + "img/bg.9eed3836.png";